import { render, staticRenderFns } from "./LoginToWorkPermit.vue?vue&type=template&id=15b6788a&"
import script from "./LoginToWorkPermit.vue?vue&type=script&lang=js&"
export * from "./LoginToWorkPermit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports